import { Location } from '@angular/common';
import { Component, HostListener, inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { DaysNoticeEnums, FrequencyEnums } from 'src/app/enum/article-task-enums';
import { ArticleTaskModel } from 'src/app/models/others/article-task.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { ArticleTaskService } from 'src/app/services/others/article-task.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-register-article-task',
  templateUrl: './register-article-task.component.html',
  styleUrls: ['./register-article-task.component.scss'],
  standalone: false
})
export class RegisterArticleTaskComponent implements OnInit {
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly branchService = inject(BranchService);
  private readonly confirmDialogService = inject(ConfirmDialogService);
  private readonly dateConverterService = inject(DateConverterService);
  private readonly formBuilder = inject(FormBuilder);
  private readonly headerService = inject(HeaderService);
  private readonly location = inject(Location);
  private readonly articleTaskService = inject(ArticleTaskService);
  private readonly title = inject(Title);
  private readonly toastHandlerService = inject(ToastHandlerService);
  private readonly userAuthenticatedService = inject(UserAuthenticatedService);
  private readonly windowService = inject(WindowService);

  @ViewChild('articleSelection') articleSelectionModalComponent?: CustomModalComponent | null = null;

  ascendantArticle: boolean = true;
  branchId: number = 0;
  columnSortArticle: string | null = null;
  componentTableSelection = CustomTableSelectComponent;
  dataArticle: PagedResponseModel<any> = new PagedResponseModel<any>();
  disabledForm: boolean = false;
  iconState: string = "lock_open";
  formArticleTask: FormGroup = new FormGroup({});
  isOpened: string | undefined = undefined;
  filtersArticle: ColumnResponseModel[] = [];
  headerArticle: ColumnResponseModel[] = [];
  inputsForArticlesSelection$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: false,
    showRecover: true,
    isMultipleSelect: false,
    filters: [],
    actions: []
  });
  listFrequencies: { label: string, value: number }[] = [
    { label: 'Ninguna', value: FrequencyEnums.ninguna },
    { label: 'Semanal', value: FrequencyEnums.semanal },
    { label: 'Mensual', value: FrequencyEnums.mensual },
    { label: 'Anual', value: FrequencyEnums.anual }
  ];
  limitArticle: number = 5;
  listArticles: any[] = [];
  listBranches: any[] = [];
  listNoticeDay: any[] = [
    { label: 'Sin aviso', value: DaysNoticeEnums.sinAviso },
    { label: '1 día antes', value: DaysNoticeEnums.unDiasAntes },
    { label: '2 días antes', value: DaysNoticeEnums.dosDiasAntes },
    { label: '3 días antes', value: DaysNoticeEnums.tresDiasAntes },
    { label: '4 días antes', value: DaysNoticeEnums.cuatroDiasAntes },
    { label: '5 días antes', value: DaysNoticeEnums.cincoDiasAntes }
  ];
  nameWindow: string = 'Captura Tareas por Artículo';
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  articleTaskContract: ArticleTaskModel = new ArticleTaskModel();
  articleTaskId: number = 0;
  titleState: string = '';
  url: string = 'article-task';
  output$ = new Subject<any>();
  pageArticle: number = 1;
  severityState: string = 'danger';
  stateText: string = 'Abierta';
  subscription: Subscription;

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.activatedRoute.params.subscribe(params => {
      this.articleTaskId = Object.keys(params).length > 0 ? params?.id : null;
    });
    await this.validateForm(this.articleTaskContract);
    await this.getPermission();
    this.handleInitialState();

    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeArticle(payload);
          break;
        case 'onFilterChange':
          this.onFilterChange(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  changeBranch() {
    const branchId = this.formArticleTask.get("branchId")?.value;
    this.articleTaskId = 0;
    const modelArticleTask = new ArticleTaskModel();
    modelArticleTask.branchId = branchId;
  }

  async changeConsecutive() {
    const branchId = this.formArticleTask.get("branchId")?.value;
    let consecutive = this.formArticleTask.get("consecutive")?.value;

    if (this.articleTaskContract.consecutive == consecutive) return;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.', 'Atención');
      return;
    }

    consecutive = consecutive === 0 ? null : consecutive;
    if (consecutive == null) {
      await this.resetArticleTask(branchId);
      return;
    }

    try {
      this.articleTaskContract = await firstValueFrom(this.articleTaskService.getArticleTaskByKeysAsync(branchId, consecutive));
      this.articleTaskId = this.articleTaskContract.articleTaskId;
      await this.validateForm(this.articleTaskContract);
      this.location.replaceState(`/${this.url}/register/${this.articleTaskId}`);
    } catch (error) {
      console.error('Error al buscar la tarea por campos de recuperación.', error);
    }
  }

  async changeState() {
    if (!this.articleTaskId || this.articleTaskId === 0) {
      this.toastHandlerService.showToast('warning', 'Debe crear una tarea.');
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `No tiene permisos para cambiar el estado de la tarea.
          Comuníquese con el administrador del sistema.`);
      return;
    }

    const frequency = this.formArticleTask.get("frequency")?.value;
    const execute = await this.confirmDialogService.confirm(`¿Desea ejecutar la tarea?`);
    if (execute) {
      if (frequency === FrequencyEnums.ninguna) {
        await this.closeTask();
      } else {
        let message = '';
        if (frequency === FrequencyEnums.semanal) {
          message = `la próxima semana`;
        } else if (frequency === FrequencyEnums.mensual) {
          message = `el próximo mes`;
        } else if (frequency === FrequencyEnums.anual) {
          message = `el próximo año`;
        }

        const schedule = await this.confirmDialogService.confirm(`¿Desea programar la tarea para ${message}?`);
        if (schedule) {
          try {
            const response = await firstValueFrom(this.articleTaskService.executeTaskAsync(this.articleTaskContract.articleTaskId));
            this.articleTaskContract = response;
            await this.validateForm(response);
            this.toastHandlerService.showToast('success', 'La tarea fue ejecutada y programada exitosamente.');
          } catch (error) {
            console.error('Error al ejecutar la tarea.', error);
          }
        } else {
          await this.closeTask();

        }
      }
    }
  }

  async closeTask() {
    try {
      const response = await firstValueFrom(this.articleTaskService.closeTaskAsync(this.articleTaskContract.articleTaskId));
      this.articleTaskContract = response;
      await this.validateForm(response);
      this.toastHandlerService.showToast('success', 'La tarea fue cerrada exitosamente.');
    } catch (error) {
      console.error('Error al cerrar la tarea.', error);
    }
  }


  async createNewRegister() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para crear tareas.
            Comuníquese con el administrador del sistema.`);
      return;
    }
    this.articleTaskId = 0;
    this.articleTaskContract = new ArticleTaskModel();
    this.articleTaskContract.branchId = this.branchId;
    await this.validateForm(this.articleTaskContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  async delete() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `El usuario no tiene permisos para eliminar tareas.
            Comuníquese con el administrador del sistema.`);
      return;
    }
    if (!this.articleTaskId || this.articleTaskId === 0) {
      this.toastHandlerService.showToast('warning', 'Debe crear una tarea.');
      return;
    }

    if (this.articleTaskContract.state) {
      this.toastHandlerService.showToast('warning', 'No es posible eliminar, la tarea ya está ejecutada.');
      return;
    }
    const accepted = await this.confirmDialogService.confirm('¿Realmente desea eliminar la tarea?');
    if (accepted) {
      try {
        await firstValueFrom(this.articleTaskService.deleteAsync(this.articleTaskContract.articleTaskId));
        this.createNewRegister();
        this.toastHandlerService.showToast('success', 'La tarea fue eliminada exitosamente.');
      } catch (error) {
        console.error('Error al eliminar la tarea.', error);
      }
    }
  }

  async handleInitialState() {
    if (this.articleTaskId !== null && this.articleTaskId !== 0) {
      await this.getArticleTaskById();
    } else {
      this.createNewRegister();
    }
  }

  async getAllBranches() {
    try {
      const response = await firstValueFrom(this.branchService.getAllBranchesForSelectAsync());
      this.listBranches = response;
    } catch (error) {
      console.error('Error al cargar las sucursales.', error);
    }
  }

  async getArticle(articleId: number | null) {
    if (articleId != null) {
      // this.articleId = articleId;
      this.formArticleTask.controls["articleId"].patchValue(articleId);
    } else {
      // this.articleId = articleId;
      this.formArticleTask.controls["articleId"].patchValue(articleId);
    }


  }

  async getArticleTaskById() {
    try {
      const response = await firstValueFrom(this.articleTaskService.getByIdAsync(this.articleTaskId));
      this.articleTaskContract = response;
      await this.validateForm(response);
      this.location.replaceState(`/${this.url}/register/${this.articleTaskId}`);
    } catch (error) {
      console.error('Error al obtener la tarea por id.', error);
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      const response = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      await this.getAllBranches();
      await this.getBranch(response.branchId, false);
    } catch (error) {
      console.error('Error al obtener la primera sucursal del usuario.', error);
    }
  }

  async getBranch(branchId: number | null, reload: boolean) {
    if (branchId != null) {
      this.branchId = branchId;
      this.formArticleTask.controls["branchId"].patchValue(branchId);
      // await this.getAllLists();
      if (reload) {
        this.createNewRegister();
      }
    } else {
      this.branchId = 0;
      this.formArticleTask.controls["branchId"].patchValue(0);
    }
  }

  async getButtonClick(buttonClick: any) {
    let consecutive = this.formArticleTask.get("consecutive")?.value;
    const branchId = this.formArticleTask.get("branchId")?.value;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.', 'Atención');
      return;
    }

    consecutive = consecutive === 0 ? null : consecutive;
    this.handleArticleTaskNavigation(buttonClick, branchId, consecutive);
  }

  async handleArticleTaskNavigation(buttonClick: any, branchId: number, consecutive: number | null) {
    const actionMap: Record<string, () => Promise<ArticleTaskModel>> = {
      first: () => firstValueFrom(this.articleTaskService.getFirstArticleTaskByKeysAsync(branchId)),
      previus: () => firstValueFrom(this.articleTaskService.getPreviusArticleTaskByKeysAsync(branchId, consecutive)),
      next: () => firstValueFrom(this.articleTaskService.getNextArticleTaskByKeysAsync(branchId, consecutive)),
      last: () => firstValueFrom(this.articleTaskService.getLastArticleTaskByKeysAsync(branchId)),
    };
    const action = actionMap[buttonClick.target.id];
    if (!action) {
      this.articleTaskId = 0;
      this.articleTaskContract = new ArticleTaskModel();
      return;
    }
    try {
      const articleTask = await action();
      this.articleTaskId = articleTask.articleTaskId;
      this.articleTaskContract = articleTask;
      await this.validateForm(this.articleTaskContract);
      this.location.replaceState(`/${this.url}/register/${this.articleTaskId}`);
    } catch (error) {
      this.articleTaskContract = new ArticleTaskModel();
      this.articleTaskContract.articleTaskId = 0;
      console.error(`Error al buscar la tarea (${buttonClick.target.id}).`, error);
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast('error', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`);
      }
    } else {
      localStorage.clear();
    }
    await Promise.all([
      this.getFirstBranchByUserAuthenticatedAsync(),
      this.getPermissionProfileByUrl(),
      this.getAllArticlesForSelect()
    ]);
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async getAllArticles() {
    try {
      this.dataArticle = await firstValueFrom(this.articleTaskService.getAllArticles(this.pageArticle, this.limitArticle, this.columnSortArticle, this.ascendantArticle, this.filtersArticle));
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de los artículos', error);
    }
  }

  async getColumnsArticle() {
    try {
      this.headerArticle = await firstValueFrom(this.articleTaskService.getColumnsForArticles());
    } catch (error) {
      console.error('Error al buscar las columnas para la selección de artículos.', error);
    }
  }

  async getAllArticlesForSelect() {
    try {
      this.listArticles = await firstValueFrom(this.articleTaskService.getAllArticlesForSelect());
    } catch (error) {
      console.error('Error al obtener la lista de artículos.', error);
    }
  }


  async handleSelectedItem(selectedItem: any) {
    const articleId = parseInt(selectedItem[0]?.id);
    this.formArticleTask.controls["articleId"].patchValue(articleId);
  }

  async onPageChangeArticle(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageArticle = event.page;
    this.limitArticle = event.pageSize;
    this.columnSortArticle = event.sortField || null;
    this.ascendantArticle = event.sortOrder === 1;
    this.getAllArticles();
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);
    this.filtersArticle = this.removeDuplicates(filters);
    this.filtersArticle.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  async openArticleSelectionModal() {
    this.filtersArticle = [];
    await Promise.all([
      this.getColumnsArticle(),
      this.getAllArticles()]
    );
    this.updateInputs();
    this.articleSelectionModalComponent && this.articleSelectionModalComponent.show();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersArticle = this.filtersArticle.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersArticle.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  async resetArticleTask(branchId: number) {
    this.articleTaskId = 0;
    this.articleTaskContract = new ArticleTaskModel();
    this.articleTaskContract.branchId = branchId;
    await this.validateForm(this.articleTaskContract);
  }

  async send() {
    this.validateFormControls();
    if (this.formArticleTask.valid) {
      const modelArticleTask = this.formArticleTask.getRawValue() as ArticleTaskModel;
      if (modelArticleTask.observation == "") modelArticleTask.observation = null;
      if (this.articleTaskId == 0) {
        try {
          const response = await firstValueFrom(this.articleTaskService.createAsync(modelArticleTask));
          this.articleTaskId = response.articleTaskId;
          this.articleTaskContract = response;
          await this.validateForm(this.articleTaskContract);
          this.location.replaceState(`/${this.url}/register/${this.articleTaskId}`);
          this.toastHandlerService.showToast('success', `La tarea fue creada exitosamente.`);
        } catch (error) {
          console.error('Error al crear la tarea.', error);
        }
      } else {
        this.articleTaskContract.description = modelArticleTask.description;
        this.articleTaskContract.observation = modelArticleTask.observation;
        this.articleTaskContract.dateArticleTask = modelArticleTask.dateArticleTask;
        this.articleTaskContract.noticeDay = modelArticleTask.noticeDay;
        this.articleTaskContract.frequency = modelArticleTask.frequency;
        try {
          const response = await firstValueFrom(this.articleTaskService.updateAsync(this.articleTaskContract));
          this.articleTaskContract = response;
          await this.validateForm(this.articleTaskContract);
          this.toastHandlerService.showToast('success', `La tarea fue modificada exitosamente.`);
        } catch (error) {
          console.error('Error al actualizar la tarea.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages(): void {
    const controlMessages: Record<string, Record<string, string>> = {
      branchId: {
        required: 'El campo sucursal es obligatorio.',
        min: 'Debes seleccionar una sucursal válida.'
      },
      articleId: {
        required: 'El campo artículo es obligatorio.',
        min: 'Debes seleccionar un artículo válido.'
      },
      description: {
        required: 'El campo descripción es obligatorio.',
        maxlength: 'El campo descripción permite máximo 80 caracteres.'
      },
      observation: {
        maxlength: 'El campo observación permite máximo 250 caracteres.'
      },
      dateArticleTask: {
        required: 'El campo fecha de la tarea es obligatorio.'
      },
      noticeDay: {
        required: 'El campo días a avisar es obligatorio.'
      },
      frequency: {
        required: 'El campo periodicidad es obligatorio.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formArticleTask.get(controlName);
      if (control && control.invalid && control.errors) {
        const errors = control.errors;
        Object.keys(errors).forEach(errorKey => {
          const message = controlMessages[controlName][errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  updateFormState() {
    if (this.articleTaskContract.state) {
      this.titleState = 'Abrir';
      this.severityState = 'success';
      this.stateText = 'Ejecutada';
      this.iconState = 'pi pi-lock-open'
      setTimeout(() => this.formArticleTask.disable());
      this.disabledForm = true;
    } else {
      this.disabledForm = false;
      this.titleState = 'Ejecutar';
      this.severityState = 'danger';
      this.stateText = 'Abierta';
      this.iconState = 'pi pi-lock'
      setTimeout(() => {
        this.formArticleTask.enable()
      });
    }

    if (this.articleTaskId != 0) {
      setTimeout(() => this.formArticleTask.controls["consecutive"].enable(), 100);
    } else {
      setTimeout(() => this.formArticleTask.controls["consecutive"].disable(), 100);
    }

    setTimeout(() => this.formArticleTask.controls["branchId"].enable(), 100);

    if (!this.permissionUpdatable) {
      this.disabledForm = true;
      setTimeout(() => this.formArticleTask.disable());
    }
  }

  updateInputs() {
    this.inputsForArticlesSelection$.next({
      headers: this.headerArticle,
      data: this.dataArticle,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: false,
      limitPaginator: true,
      filters: this.filtersArticle,
      actions: [
        {
          action: 'view-image',
          label: 'Imágenes',
          icon: 'pi pi-image'
        }
      ]
    });
  }


  async validateForm(articleTask: ArticleTaskModel) {
    this.formArticleTask = this.formBuilder.group({
      branchId: [articleTask.branchId, [Validators.required, Validators.min(1)]],
      consecutive: [{ value: articleTask.consecutive, disabled: this.articleTaskId === 0 }, [Validators.required]],
      articleId: [articleTask.articleId, [Validators.required, Validators.min(1)]],
      description: [articleTask.description, [Validators.required, Validators.maxLength(80)]],
      observation: [articleTask.observation, [Validators.maxLength(250)]],
      dateArticleTask: [articleTask.dateArticleTask ? this.dateConverterService.convertUtcToLocalDate(articleTask.dateArticleTask) : null, [Validators.required]],
      noticeDay: [articleTask.noticeDay, [Validators.required]],
      frequency: [articleTask.frequency, [Validators.required]],
      state: [articleTask.state, [Validators.required]],
    });
    await this.getArticle(articleTask.articleId);
    this.updateFormState();

  }

  validateFormControls() {
    Object.keys(this.formArticleTask.controls).forEach((key) => {
      const control = this.formArticleTask.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
